import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const UnpublishedJobNotice = () => {
  return (
    <Box width="full" paddingTop="s96" paddingX="s24" justifyContent="flexEnd">
      <Box alignItems="center" gap="s16" width="full">
        <Icon.Large icon="briefcase" color="grey600" />
        <Box textAlign="center">
          <Text color="grey1000" size="300" weight="semibold">
            {i18n.t('ats.job_details.standard_portals.unpublished_notice.title')}
          </Text>
          <Text size="300">
            {i18n.t('ats.job_details.standard_portals.unpublished_notice.description')}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}
